/* unplugin-vue-components disabled */import i18n from '@/lang';
/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExtField from '@/components/ExtField';
export default {
  name: 'pageInfo',
  props: {
    eventExtFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    eventInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    productList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    coordinationList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    eventTmpl: Object,
    serviceList: Array
  },
  components: {
    ExtField: ExtField
  },
  data: function data() {
    return {
      priorityMap: {
        1: i18n.tc("88"),
        2: i18n.tc("89"),
        3: i18n.tc("90")
      }
    };
  }
};